// export default {
//   "HOST": "http://api.transnext.com.hk:8000",
// }

export default {
  "HOST": "http://api.transnext.cn",
}



// WEBPACK FOOTER //
// ./src/settings.js